export default "__VITE_ASSET__DgIyrzgy__"